import React from 'react';

type Props = {
  topics?: string[] | [];
};

export const Topics: React.FC<Props> = ({ topics }): JSX.Element => {
  const attrs = {
    wrapper: { className: 'topics' },
    header: { className: 'topics__header' },
    body: {
      wrapper: { className: 'topics__body' },
      item: { className: 'topics__body-item' },
      text: { className: 'topics__body-item-text' },
      tooltip: {
        className: 'topics__body-item-toltip',
      },
      emptyTopicsMessage: { className: 'topics__body-message' },
    },
  };

  const topicsToShow =
    topics && topics.length ? (
      <div {...attrs.body.wrapper}>
        {topics.map((el: string) => (
          <div key={el} {...attrs.body.item}>
            <span {...attrs.body.tooltip}>{el}</span>
            <div {...attrs.body.text}>{el}</div>
          </div>
        ))}
      </div>
    ) : (
      <div {...attrs.body.emptyTopicsMessage}>
        No topics detected for this message.
      </div>
    );

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.header}>Topics</div>
      {topicsToShow}
    </div>
  );
};
